import script from "./BrandUpsert.vue?vue&type=script&lang=ts&setup=true"
export * from "./BrandUpsert.vue?vue&type=script&lang=ts&setup=true"

import "./BrandUpsert.vue?vue&type=style&index=0&id=6cb7d601&lang=scss"

const __exports__ = script;

export default __exports__